import React from "react";
import {
    TableContainer, TableRow,
    TableCell, Table, TableHead, TableBody
} from "@mui/material";
import { useTranslation } from "react-i18next";

const TableClients = ({ clientList }) => {
    const { t } = useTranslation(['document','common']);
 
    return (
        <TableContainer>
            <Table aria-label="simple table" style={{ padding: '0px !important' }}>
                <TableHead>
                    <TableRow>
                        <TableCell className='table-row-info' style={{ paddingLeft: 30 }}>{t("common:commonNameLbl")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {clientList.length === 0 &&
                        <TableRow key='empty'>
                            <TableCell colSpan={1} style={{ textAlign: 'center' }}>
                            {t("common:commonNoResultsLbl")}
                                </TableCell>
                        </TableRow>
                    }
                    {clientList.map(item => (
                        <TableRow key={item.id}>
                            <TableCell component="th" scope="row" className='table-row-name' style={{ paddingLeft: 30 }}>
                                {item.name}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default TableClients;